module.exports = __webpack_public_path__ + "static/media/5.6245ae53.jpg";